var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-header"},[_c('back-btn',{attrs:{"text":_vm.text,"canReturn":_vm.canReturn,"backRoute":_vm.backRoute,"shouldPop":_vm.shouldPop,"dark":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }